import { NO_TRANSLATE_CLASS } from "@flat-ui";

/**
 * Class of the "+N more" popover of the markups calendar, which shows a date and is rendered outside
 * of the calendar, so it is not covered by its NO_TRANSLATE_CLASS. It is
 * `eventCalendarClasses.moreEventsPopover`, written out so the scheduler stays lazy-loaded.
 */
export const MORE_EVENTS_POPOVER_CLASS = "MuiEventCalendar-moreEventsPopover";

/** Classes of the elements that LocalizeJS skips together with all their children */
export const LOCALIZE_BLOCKED_CLASSES = [NO_TRANSLATE_CLASS, MORE_EVENTS_POPOVER_CLASS];
/**
 * Determines whether new phrases should be allowed to be sent to Localize.
 * Based on the environment and user settings.
 * For numbered environments and localhost, it relies on the isTranslationOverrideAllowed feature flag.
 * For non-numbered environments (Dev, Staging, Prod), it always returns true.
 */
export function shouldEnableSaveNewPhrases({
  isNumberedDevEnvironment,
  isLocalhost,
  isTranslationOverrideAllowed
}) {
  // For all numbered environments or localhost rely on the isTranslationOverrideAllowed flag value
  if (isNumberedDevEnvironment || isLocalhost) {
    return isTranslationOverrideAllowed;
  }

  // Always return true for non-numbered environments in dev, staging and prod
  return true;
}